import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  & > p {
  }

  & > div {
  }
`;

const ErrorMessage = ({ message, actionButtons }) => (
  <Container>
    <p>{message}</p>
    {actionButtons && <div>{actionButtons}</div>}
  </Container>
);

ErrorMessage.defaultProps = {
  actionButtons: null,
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  actionButtons: PropTypes.any,
};

export default ErrorMessage;
